import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import WeddingGenerator from "../pages/WeddingGenerator";

function AllRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/weddinggenerator" element={<WeddingGenerator />} />
    </Routes>
  );
}

export default AllRoutes;
